import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import { useDelivery } from '../context/DeliveryContext';
export default function DeliveryPanels() {
  const { deliveries, onView, loading, error } = useDelivery();
  if (loading || error) return null;
  const issues = deliveries.filter(delivery => delivery.outcome === 'REJECTED' || delivery.itemResults.some(result => result.status === 'ISSUE'));
  return <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
    <h2 className="mb-4 flex items-center gap-2 text-base font-bold text-slate-900"><FiAlertCircle className="text-red-600" /> Delivery Issues</h2>
    {issues.length === 0 ? <p className="text-sm text-slate-500">No delivery issues recorded for this date.</p> : <div className="divide-y divide-slate-100">
      {issues.map(delivery => <button key={delivery.id} onClick={() => onView(delivery)} className="flex w-full flex-wrap justify-between gap-2 py-3 text-left text-sm hover:bg-slate-50">
        <span className="font-semibold text-slate-800">#{delivery.id} · {delivery.supplier}</span>
        <span className="text-red-600">{delivery.itemResults.filter(result => result.status === 'ISSUE').length} issues{delivery.outcome === 'REJECTED' ? ' · Goods rejected' : ''}</span>
      </button>)}
    </div>}
  </section>;
}
